import request from "@/utils/followUp/request";

const BASE_URL = "/sysRole";

// 角色管理-分页列表
export function rolePageList(query) {
  return request({
    url: `${BASE_URL}/page`,
    method: "get",
    params: query,
  });
}

// 角色管理-全部列表
export function getRoleAllList(query) {
  return request({
    url: `${BASE_URL}/getAll`,
    method: "get",
    params: query,
  });
}

// 角色管理-保存
export function saveRole(data) {
  return request({
    url: `${BASE_URL}/save`,
    method: "post",
    data,
  });
}

// 角色管理-删除
export function delRole(id) {
  return request({
    url: `${BASE_URL}/del/${id}`,
    method: "post",
  });
}

// 角色管理-启用
export function enableRole(id) {
  return request({
    url: `${BASE_URL}/enable/${id}`,
    method: "post",
  });
}

// 角色管理-停用
export function disableRole(id) {
  return request({
    url: `${BASE_URL}/disable/${id}`,
    method: "post",
  });
}
